<template>
  <div>
    <!-- 返回 开始 -->
    <div class="page_topbox">
      <img class="page_topreturn" src="/static/fanhui.png" @click="pageReturn()" />
      <div class="page_toptext">车辆年检</div>
      <img class="page_topreturnindex" src="/static/fanhuishouye.png" @click="pageToIndex()" />
    </div>
    <!-- 返回 结束 -->
    <div class="inspection-bg">
      <!-- <div class="inspection-bannertip1">提交订单 → 审核资料 → 司机上门取车 → 司机代办年检 → 办理完成</div>
      <div class="inspection-bannertip2">司机到您指定地点取车，办完年检后，再送回</div>
      <div class="inspection-bannertip2">注意：请确保车辆违章已处理完毕</div> -->
    </div>


    <div class="inspection-mesg">
      <div class="inspection-choosecar" @click="toCarLicenseList()">
        <img class="inspection-mesgicon" src="/static/chepai.png" />
        <div class="inspection-choosebox">
          <div :class="licenseItem.car_no?'inspection-carnum1':'inspection-carnum'">{{licenseItem.car_no? licenseItem.car_no : '请选择车辆'}}</div>
          <img class="inspection-checkmore" src="/static/newicon/more.png" />
        </div>
      </div>
      <div class="inspection-mesginput">
        <img class="inspection-mesgicon" src="/static/name.png" />
        <input class="inspection-name" placeholder="请输入联系人姓名" v-model="name" />
      </div>
      <div class="inspection-mesginput">
        <img class="inspection-mesgicon" src="/static/dianhuaicon.png" />
        <input class="inspection-name" placeholder="请输入联系人电话" v-model="phone" />
      </div>
      <div class="inspection-mesginput1">
        <div class="inspection-addressbox">
          <img class="inspection-mesgicon" src="/static/dizhiicon.png" />
          <!-- @click="toChooseLocation()" -->
          <!-- <div :class="address? 'inspection-carnum1' : 'inspection-carnum'"  @click="keySearch1()">{{address ? address : '请选择地址'}}</div> -->
          <input class="inspection-name" placeholder="请选择地址" disabled="true" v-model="address" />
        </div>
        <img class="inspection-checkmore" src="/static/dingwei.png" @click="toChooseLocation()" />
        <!-- @input="keySearch()"   @click="toChooseLocation()"-->
      </div>
      <div class="inspection-mesginput">
        <img class="inspection-mesgicon" src="/static/dizhiicon.png" />
        <input class="inspection-name" name="yearlyInspection" placeholder="请输入详细地址:如门牌号、楼栋号等" v-model="address11" />
      </div>
      <div class="inspection-mesginput" @click="showDatepop()">
        <img class="inspection-mesgicon" src="/static/timeicon.png" />
        <div :class="date?'inspection-time1' : 'inspection-time'">{{date? date : '请选择预约日期'}}</div>
      </div>
      <div class="inspection-mesginput" @click="showTimepop()">
        <img class="inspection-mesgicon" src="/static/timeicon.png" />
        <div :class="time? 'inspection-time1' : 'inspection-time'">{{time? time : '请选择预约时间'}}</div>
      </div>
      <div v-if="showaddressList">
        <div class="addressList">
          <div class="addressBox" v-for="(item, index) in search_list" :key="index" @click="onResLi(item)">
            <div class="address_name">{{item.name}}</div>
            <div class="address_detail">{{item.address}}</div>
          </div>
          <div class="noSearchShow" v-if="noSearchShow" @click="none()"></div>
        </div>
      </div>
      <!-- <ul>
          <li v-for="(item, index) in search_list" :key="index" @click="onResLi(item)">
            <span>{{item.name}}</span>
            <p>{{item.address}}</p>
          </li>
          <li v-if="noSearchShow">
            <p>暂无搜索结果</p>
          </li>
        </ul> -->

    </div>
    <!-- <div class="inspection-none"></div> -->
    <!--   <div class="inspection-upimgbox">
      <div v-if="show" class="inspection-upimgbox1">
        <img class="inspection-upimg" src="/static/shangchuan.png" />
      </div>
      <div v-else class="inspection-upimgbox1">
        <img :src="image" alt="" class="inspection-upimg1">
      </div>
      <input type="file" class="fileinput" accept="image/*" @change='getimg($event)' />
    </div> -->
    <div class="inspection-price">
      <div class="inspection-pricetitle1">
        <img class="inspection-priceicon" src="/static/newprojecticon/title.png" />
        <div class="inspection-pricetitlename">服务价格</div>
      </div>
      <div class="inspection-price1" style="margin-bottom: 10px;">
        <div class="inspection-pricetitle">
          <div class="inspection-pricetitlename">服务价格</div>
        </div>
        <div class="service-price">￥{{cityServiceDetail.agent_fee}}</div>
      </div>
      <!-- <div class="inspection-price1">
        <div class="inspection-pricetitle">
          <div class="inspection-pricetitlename">车辆检测费</div>
        </div>
        <div class="service-price">￥{{cityServiceDetail.agent_product_price}}</div>
      </div> -->
    </div>
    <!-- 结算方式 开始 -->
    <!-- <div class="reserceDesc_yuyuemesg">
        <div class="reserceDesc_fuwutitle">
          <img class="reserceDesc_fuwuimg" src="/static/newicon/title2.png" />
          <div class="reserceDesc_fuwutitlename">结算方式</div>
        </div>
        <div class="reserceDesc_fuwuDetail">
          <div class="reserceDesc_fuwuprice">
            <div class="reserceDesc_fuwupricename">可用余额</div>
            <div class="reserceDesc_jiesuancheck">
              <div class="reserceDesc_jiesuanpricenum">￥{{amount}}</div>
              <input type="radio" name="pay_type" />
            </div>
          </div>
          <div class="reserceDesc_fuwuprice" @click="showPopup()">
            <div class="reserceDesc_fuwupricename">服务券</div>
            <div class="reserceDesc_jiesuancheck">
              <div class="reserceDesc_jiesuanpricenum"></div>
              <div class="reserceDesc_jiesuanpricenum">已选</div>
              <div class="reserceDesc_jiesuanpricenum">未选</div>
              <input type="radio" name="pay_type" />
            </div>
          </div>
        </div>
      </div> -->
    <!-- 结算方式 结束 -->
    <div class="reserceDesc-material">
      <div class="material-title">
        <img class="material-titleicon" src="/static/newprojecticon/title.png" />
        <div class="material-titlename">年检所需材料</div>
      </div>
      <div class="material-box">
        <div class="material-mesg">
          <img class="material-mesgicon" src="/static/xingshizheng.png" />
          <div class="material-mesgtext">行驶证</div>
          <div class="material-mesgtexttip">原件</div>
        </div>
        <div class="material-mesg">
          <img class="material-mesgicon" src="/static/jiaoqiangxian.png" />
          <div class="material-mesgtext">交强险报单</div>
          <div class="material-mesgtexttip">有效期内</div>
        </div>
        <div class="material-mesg">
          <img class="material-mesgicon" src="/static/shenfenzheng.png" />
          <div class="material-mesgtext">办理人身份证</div>
          <div class="material-mesgtexttip">原件</div>
        </div>
      </div>
    </div>
    <div class="inspection-yuyue" @click="appointment()">确认提交</div>
    <div></div>
    <!-- 支付 开始 -->
    <!-- <div class="page_button reserceDesc_button" @click="package_id=='' ? (!!settlementItem.selectedID ? reserve(): yuyuepay()): reserve()">
      <div class="page_zhifu">{{ package_id=='' ? "确定支付并预约保养" : "预约保养" }}</div>
    </div> -->
    <!-- 支付 结束 -->
    <!-- 日期弹出层 开始 -->
    <van-popup v-model="showDate" position="bottom" :style="{ height: '40%' }" round>
      <van-datetime-picker v-model="currentDate" :formatter="formatter" @confirm="checkDate" @cancel="onDateCancel"
        type="date" title="选择年月日" :min-date="minDate" :max-date="maxDate" />
    </van-popup>
    <!-- 日期弹出层 结束 -->
    <!-- 时间弹出层 开始 -->
    <van-popup v-model="showTime" position="bottom" :style="{ height: '40%' }" round>
      <!-- <van-picker title="选择时间" show-toolbar :columns="times" @confirm="checkTime" @cancel="onTimeCancel" /> -->
      <van-datetime-picker v-model="currentTime" @confirm="checkTime" @cancel="onTimeCancel" type="time" :max-hour="maxHour" />
    </van-popup>
    <!-- 时间弹出层 结束 -->
    <!-- section-method:可使用券 start -->

    <van-popup v-model="showkaquan" position="bottom" :style="{ 'max-height': '70%' }">
      <div class="popup_top" @click="guanbi()">
        <img class="guanbi" src="/static/guanbi.png" />
        <div>可使用券</div>
      </div>
      <!-- <div class="couponCont maskCont">
        <div class="reserceDesc_section">
          <div class="scroll-div">
            <div class="couponCell" hover-class="weui-cell_active">
              <div class="cellLeft" @click="couponChange(index)">
                <div>{{ item.product.id == serviceItem.product_id ? '可用':'不可用' }}</div>
                <div class="cont">{{ item.product ? item.product.name : '' }}</div>
                <div>编号: {{ item.card_no }}</div>
                <div>到期: {{ item.overdue_at }}</div>
              </div>
              <input type="radio" @click="couponChange(index)" id="couponChange" name="coupon" :data-index="index"
                :disabled="item.product.id != serviceItem.product_id" :checked=" item.checked " />
            </div>
          </div>
        </div>
      </div> -->
    </van-popup>
    <!-- section-method:可使用券 end -->
    <!-- 选择地址 开始 -->
    <!--  <div v-if="showaddress" class="map">
      <iframe id="mapPage" :src="reportUrl" frameborder="0" :style="{width: width, height:height}">
      </iframe>
    </div> -->
    <!-- 选择地址 结束 -->
  </div>
</template>

<script>
  import httper from '../../api/http';
  import eventBus from '../../../static/js/eventbus.js';
  import {
    Dialog
  } from 'vant';
  export default {
    data() {
      return {
        name: "", //联系人
        phone: "", //联系人电话
        address: "", //地址
        address1: "",
        address11: "", //详细地址
        show: true,
        image: "",
        id: "",
        inspectiondetail: "",
        amount: "", //用户所有积分数
        showkaquan: false,
        licenseItem: "", //车辆信息
        showaddress: false,
        height: window.innerHeight + 'px',
        width: '100%',
        search_key: '', //搜索值
        lists: [], //地点列表
        search_list: [], //搜索结果列表
        noSearchShow: false,
        showaddressList: false,
        showDate: false, //是否显示日期弹框
        showTime: false, //是否显示时间弹框
        reportUrl: 'https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=FERBZ-BYILQ-G7U5O-G2USJ-H7VWJ-CJFNE&referer=myapp',
        minDate: new Date(),
        maxDate: new Date(2025, 12, 31),
        currentDate: new Date(),
        // minHour:"10",
        maxHour: "23",
        currentTime: "12:00",
        time: "",
        date: "",
        // times: ['07:00-08:00', '08:00-09:00', '09:00-10:00', '10:00-11:00', '11:00-12:00', '12:00-13:00', '13:00-14:00',
        //   '14:00-15:00', '15:00-16:00', '16:00-17:00', '17:00-18:00'
        // ]
        times: [],
        store_id: "",
        serviceDetail: "",
        product_name: "",
        product_type: "",
        latitude: "", // 微信api获取用户当前纬度,默认为空22.51595
        longitude: "", // 微信api获取用户当前经度,默认为空113.3926
        city: "中山市", // 用户所在市区,默认为空中山市
        cityServiceDetail: {}
      }
    },
    created() {
      this.getwechat({
        url: location.href.split('#')[0]
      })
      // eventBus.$on('address', function(data){
      //         console.log(data,"data");
      //       }.bind(this));
      //最小日期
      // var day3 = new Date();
      // day3.setTime(day3.getTime() + 24 * 60 * 60 * 1000);
      // var resDate = day3.getFullYear() + "/" + (day3.getMonth() + 1) + "/" + day3.getDate();
      // this.minDate = new Date(resDate)
      //最小日期
      var resDate = "2021/01/01";
      this.minDate = new Date(resDate)

      if (this.$route.query.product_id) {
        this.id = Number(this.$route.query.product_id);
      }
      if (this.$route.query.licenseItem) {
        this.licenseItem = JSON.parse(this.$route.query.licenseItem)
        this.name = this.licenseItem.owner
      }

      if (this.$route.query.product_name) {
        this.product_name = this.$route.query.product_name
      }

      //上页面获取商品服务类型
      if (this.$route.query.product_type) {
        this.product_type = this.$route.query.product_type;
      }

      // if (this.$route.query.name) {
      //   this.name = this.$route.query.name;
      // }
      if (localStorage.getItem('userinfo')) {
        this.phone = JSON.parse(localStorage.getItem('userinfo')).mobile;
      } else {
        Dialog.confirm({
            title: '提示',
            message: '请先绑定手机',
          })
          .then(() => {
            that.$router.push({
              path: "/changePhoneNum"
            })
          })
          .catch(() => {
            return false;
          });
      }
      if (this.$route.query.phone) {
        this.phone = this.$route.query.phone;
      }
      if (this.$route.query.address11) {
        this.address11 = this.$route.query.address11;
      }
      if (this.$route.query.date) {
        this.date = this.$route.query.date;
      }
      if (this.$route.query.time) {
        this.time = this.$route.query.time;
      }
      console.log("this.$route.query.address", this.$route.query.address)
      if (this.$route.query.address) {
        this.address1 = JSON.parse(this.$route.query.address)
        if (this.address1.pname) {
          this.address = this.address1.pname + this.address1.cityname + this.address1.address + this.address1.name
        } else {
          this.address = this.address1.address + this.address1.name
        }
      }

      // if (!sessionStorage.getItem("latitude") || !sessionStorage.getItem("longitude") || !sessionStorage.getItem("city")) {
      //   // this.getMyLocation()
      //   this.getWxLocation()
      // }
      this.getWxLocation()
      // //获取纬度
      // if (sessionStorage.getItem("latitude")) {
      //   this.latitude = sessionStorage.getItem("latitude")
      // }
      // //获取经度
      // if (sessionStorage.getItem("longitude")) {
      //   this.longitude = sessionStorage.getItem("longitude")
      // }
      // //获取城市

      // if (sessionStorage.getItem("city")) {
      //   this.city = sessionStorage.getItem("city")
      //   this.request("getCityConfig", {
      //     city: this.city
      //   })
      // }
      if (this.$route.query.store_id) {
        this.store_id = this.$route.query.store_id
      } else {
        this.store_id = ""
      }
      // let getstoredata = {
      //   id: this.store_id,
      // }
      // this.request("getStore", getstoredata);

      this.request("getDetail", {
        id: this.id
      })
      // this.request("getServiceDetail", {
      //   name: this.product_name,
      //   store_id: this.store_id
      // })
      this.request('getUserInfo')
      this.getChoosetime()
      this.request("getCityConfig", {
        city: this.city
      })
    },
    mounted() {
      // adMap() {
      //   //初始化地图
      //   var map = new AMap.Map('container', {
      //     zoom: 14, //缩放级别
      //     center: this.center, //设置地图中心点
      //     //resizeEnable: true, //地图初始化加载定位到当前城市
      //   });
      //   //获取初始中心点并赋值
      //   var currentCenter = map.getCenter(); //此方法是获取当前地图的中心点
      //   this.center = [currentCenter.lng, currentCenter.lat]; //将获取到的中心点的纬度经度赋值给data的center
      //   //根据地图中心点查附近地点，此方法在下方
      //   this.centerSearch();
      //   //监听地图移动事件，并在移动结束后获取地图中心点并更新地点列表
      //   var moveendFun = (e) => {
      //     // 获取地图中心点
      //     currentCenter = map.getCenter();
      //     this.center = [currentCenter.lng, currentCenter.lat]
      //     //根据地图中心点查附近地点
      //     this.centerSearch();
      //   }
      //   // 绑定事件移动地图事件
      //   map.on('moveend', moveendFun);
      // },
    },
    methods: {
      pageReturn() {
        this.$router.go(-1)
      },
      pageToIndex() {
        this.$router.push({
          path: "/"
        })
      },
      showDatepop() {
        this.showDate = true
      },
      showTimepop() {
        this.showTime = true
      },
      //选择日期
      checkDate(value) {
        let times1 = [{
          starttime: 8,
          endtime: 9,
          time: "8:00-9:00",
          ischeck: false,
          isOptional: false
        }, {
          starttime: 9,
          endtime: 10,
          time: "9:00-10:00",
          ischeck: false,
          isOptional: false
        }, {
          starttime: 10,
          endtime: 11,
          time: "10:00-11:00",
          ischeck: false,
          isOptional: false
        }, {
          starttime: 11,
          endtime: 12,
          time: "11:00-12:00",
          ischeck: false,
          isOptional: false
        }, {
          starttime: 14,
          endtime: 15,
          time: "14:00-15:00",
          ischeck: false,
          isOptional: false
        }, {
          starttime: 15,
          endtime: 16,
          time: "15:00-16:00",
          ischeck: false,
          isOptional: false
        }, {
          starttime: 16,
          endtime: 17,
          time: "16:00-17:00",
          ischeck: false,
          isOptional: false
        }, {
          starttime: 17,
          endtime: 18,
          time: "17:00-18:00",
          ischeck: false,
          isOptional: false
        }]
        let d = new Date(value)
        let resDate = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
        this.date = resDate
        this.showDate = false
        let datestart = new Date().getTime()
        var datedate = new Date(datestart).getDate();
        if (d.getDate() == datedate) {
          this.getChoosetime()
        } else {
          let times = []
          times1.map(function(item, i) {
            times.push(
              item.time
            )
          })
          this.times = times
        }
        //let times1 = this.times
      },
      //取消弹框日期
      onDateCancel() {
        this.showDate = false
      },
      //选择时间
      checkTime(value) {

        this.time = value
        this.showTime = false
      },
      //获取时间段
      getChoosetime() {
        let datestart = new Date().getTime()
        var hourse = new Date(datestart).getHours()
        var datedate = new Date(datestart).getDate();
        let times1 = [{
          starttime: 8,
          endtime: 9,
          time: "8:00-9:00",
          ischeck: false,
          isOptional: false
        }, {
          starttime: 9,
          endtime: 10,
          time: "9:00-10:00",
          ischeck: false,
          isOptional: false
        }, {
          starttime: 10,
          endtime: 11,
          time: "10:00-11:00",
          ischeck: false,
          isOptional: false
        }, {
          starttime: 11,
          endtime: 12,
          time: "11:00-12:00",
          ischeck: false,
          isOptional: false
        }, {
          starttime: 14,
          endtime: 15,
          time: "14:00-15:00",
          ischeck: false,
          isOptional: false
        }, {
          starttime: 15,
          endtime: 16,
          time: "15:00-16:00",
          ischeck: false,
          isOptional: false
        }, {
          starttime: 16,
          endtime: 17,
          time: "16:00-17:00",
          ischeck: false,
          isOptional: false
        }, {
          starttime: 17,
          endtime: 18,
          time: "17:00-18:00",
          ischeck: false,
          isOptional: false
        }]
        let times = []
        times1.map(function(item, i) {
          // if (item.starttime < hourse) {
          //   item.isOptional = false
          // } else {
          item.isOptional = true;
          if (item.isOptional) {
            times.push(
              item.time
            )
          }
          //}
        })
        this.times = times
        if (this.times.length == 0) {
          this.times = [{
            time: "今日已约满",
          }]
        }
        //this.times = times1
      },
      //取消时间弹框
      onTimeCancel() {
        this.showTime = false
      },
      formatter(type, val) {
        if (type === 'year') {
          return `${val}年`;
        } else if (type === 'month') {
          return `${val}月`;
        } else if (type === 'day') {
          return `${val}日`;
        }
        return val;
      },
      //获取微信配置信息接口
      getwechat(requestData = {}) {
        httper.get("wechat/wechat/sign-package", requestData, res => {
          //wx.ready(() => {
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.appId, // 必填，公众号的唯一标识
            timestamp: res.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.nonceStr, // 必填，生成签名的随机串
            signature: res.signature, // 必填，签名
            jsApiList: ["getLocation"] // 必填，需要使用的JS接口列表
          });
        })

        //});
      },
      getWxLocation() {
        let that = this
        console.log("定位")
        wx.ready(() => {
          wx.getLocation({
            type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
            success: function(res) {
              var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
              var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
              var speed = res.speed; // 速度，以米/每秒计
              var accuracy = res.accuracy; // 位置精度
              that.latitude = latitude;
              that.longitude = longitude;
              sessionStorage.setItem("latitude", latitude)
              sessionStorage.setItem("longitude", longitude)
              var geocoder = new qq.maps.Geocoder();
              var latLng = new qq.maps.LatLng(latitude, longitude);
              //设置服务请求成功的回调函数
              geocoder.setComplete(function(result) {
                that.city = result.detail.addressComponents.city
                sessionStorage.setItem("city", result.detail.addressComponents.city)
              });
              this.request("getCityConfig", {
                city: this.city
              })
              //若服务请求失败，则运行以下函数
              geocoder.setError(function() {

              });
              //对指定经纬度进行解析
              geocoder.getAddress(latLng);
            }
          });
        });
      },
      //关闭弹出层
      guanbi() {
        this.showkaquan = false
      },
      //显示弹出层
      showPopup() {
        this.showkaquan = true
      },
      //腾讯地图选择地址
      toChooseLocation() {
        this.$router.push({
          path: "/chooseLocation",
          query: {
            product_id: this.id,
            name: this.name, //联系人
            phone: this.phone, //联系人电话
            address11: this.address11, //详细地址
            licenseItem: JSON.stringify(this.licenseItem),
            date: this.date,
            time: this.time,
            store_id: this.store_id,
            product_name: this.product_name,
            product_type: this.product_type,
            city: this.city,
            items: "yearlyInspection",
          }
        })
      },
      //选择车牌
      toCarLicenseList() {
        let isSelectLicense = true
        this.$router.push({
          path: "/CarLicenseList",
          query: {
            product_id: this.id,
            isSelectLicense: isSelectLicense,
            name: this.name, //联系人
            phone: this.phone, //联系人电话
            address: JSON.stringify(this.address1), //地址
            address11: this.address11, //详细地址
            date: this.date,
            time: this.time,
            store_id: this.store_id,
            product_name: this.product_name,
            product_type: this.product_type,
            city: this.city
          }
        })
      },
      //提交
      appointment() {
        let that = this
        let yearConfirmMesg = {}
        if (!that.licenseItem.car_no) {
          this.$toast({
            message: '请选择本服务车辆'
          })
          return
        }
        if (!that.name) {
          this.$toast({
            message: '请输入联系人姓名',
          });
          return
        }
        if (!that.phone) {
          this.$toast({
            message: '请输入联系人电话',
          });
          return
        }
        if (!that.address) {
          this.$toast({
            message: '请选择地址',
          });
          return
        }
        yearConfirmMesg = {
          car_no: that.licenseItem.car_no,
          name: that.name,
          phone: that.phone,
          address: (that.address) + (that.address11),
          address11: this.address11, //详细地址
          price: that.cityServiceDetail.agent_product_price,
          driving_license_id: that.licenseItem.id,
          product_id: that.id,
          book_date: that.date,
          book_time: that.time,
          service_price: that.cityServiceDetail.agent_fee,
          store_id: this.store_id,
          product_item_id: that.serviceDetail.id,
          product_type: this.product_type,
          city: this.city,
          lat: this.address1.location.lat,
          lng: this.address1.location.lng,
          serviceName: that.inspectiondetail.name,
          Drivingtype: true
        }
        this.$router.push({
          path: "/yearlyconfirm",
          query: {
            yearConfirmMesg: JSON.stringify(yearConfirmMesg)
          }
        })
      },
      // 调用接口
      request(type = '', requestData = {}) {
        let that = this
        switch (type) {
          case 'getDetail':
            httper.get('/product/detail', requestData, res => {
              if (res.code == 0) {
                this.inspectiondetail = res.data
              } else {
                this.$toast({
                  message: res.message || '系统异常'
                })
              }
            })
            break
            // 获取店铺详情
          case "getStore":
            httper.get(
              "store/store-detail",
              requestData,
              res => {
                that.storeDesc = res.data;
                that.latitude = res.data.latitude
                that.longitude = res.data.longitude
              },
              false
            );
            break;
            //获取城市服务
          case 'getCityConfig':
            httper.get('/sys/get-city-config', requestData, res => {
              that.cityServiceDetail = res.data
            }, false)
            break
            //获取个人信息余额
          case 'getUserInfo':
            httper.get('/wechat/user/info', requestData, res => {
              if (res.code == 0) {
                var amount1 = res.data.account.amount.toFixed(2)
                that.amount = amount1
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
            //获取服务详情
          case 'getServiceDetail':
            httper.get('/store/service-detail', requestData, res => {
              that.serviceDetail = res.data
            }, false)
            break
        }
      },

    },

  }
</script>

<style scoped="scoped">
  .inspection-bg {
    width: 100%;
    height: 195px;
    background-size: 100% 100%;
    background-image: url(../../../static/daijianianjianbanner.png);
    /* background: linear-gradient(0deg, #EA6E56 0%, #E2523E 100%);
padding: 20px;
box-sizing: border-box; */

  }

  .van-picker__toolbar {
    align-items: center;
  }

  .inspection-upimgbox {
    width: calc(100% - 40px);
    margin: 0 20px 20px 20px;
    background-color: #fff;
    border-radius: 8px;
    /* height: 130px; */
    height: 252px;
    padding: 20px;
    box-sizing: border-box;
    box-shadow: 0px 4px 5px 2px rgba(187, 187, 187, 0.3);
    /* position: absolute;
    top: 158px; */
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .inspection-upimgbox1 {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .fileinput {
    opacity: 0;
    position: absolute;
    /* top: 0;
    left: 0;
    width: 100%;
    height: 100%; */
    cursor: pointer;
    width: 90%;
    height: 252px;
    border-radius: 24px;
  }

  .inspection-none {
    width: 100%;
    /* height: 110px; */
    /* height: 232px; */
    height: 175px;
  }

  .inspection-upimg {
    width: 100%;
    height: 100%;
  }

  .inspection-upimg1 {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    /* position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto; */
  }

  .inspection-mesg {
    width: calc(100% - 40px);
    margin: 0 20px;
    padding: 20px;
    box-sizing: border-box;
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 0px 4px 5px 2px rgba(187, 187, 187, 0.3);
    /* position: absolute;
    top: 158px; */
    position: relative;
    /* top: -50px; */
    top: -30px;
  }

  .inspection-mesginput {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    height: 30px;
  }

  .inspection-mesginput1 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    height: 30px;
    width: 100%;
  }

  .inspection-addressbox {
    display: flex;
    align-items: center;
    width: 88%;
  }

  .inspection-mesgicon {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }

  input {
    border: none;
  }

  ::-webkit-input-placeholder {
    font-size: 16px;
    color: #BBBBBB;
    text-align: left;
    background-color: transparent;
  }

  .inspection-choosecar {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    height: 30px;
  }

  .inspection-mesgicon {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }

  .inspection-choosebox {
    width: 90%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .inspection-carnum {
    font-size: 16px;
    color: #BBBBBB;
  }

  .inspection-carnum1 {
    font-size: 16px;
  }

  .inspection-checkmore {
    width: 15px;
    height: 15px;
  }

  .inspection-name {
    font-size: 16px;
    height: 30px;
    width: 280px;
  }

  .inspection-name ::-webkit-input-placeholder {
    font-size: 16px;
    color: #BBBBBB;
    text-align: start;
  }

  .inspection-price {
    width: calc(100% - 40px);
    margin: -20px 20px 20px 20px;
    padding: 20px;
    box-sizing: border-box;
    /* display: flex;
    justify-content: space-between;
    align-items: center; */
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 0px 4px 5px 2px rgba(187, 187, 187, 0.3);
  }

  .inspection-price1 {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .inspection-pricetitle {
    display: flex;
    align-items: center;
  }

  .inspection-pricetitle1 {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .inspection-priceicon {
    width: 4px;
    height: 23px;
    margin-right: 10px;
  }

  .inspection-pricetitlename {
    font-size: 12px;
  }

  /* .service-price {
    color: #E35340;
    font-size: 12px;
  } */

  .reserceDesc-material {
    width: calc(100% - 40px);
    margin: 0 20px 80px 20px;
    padding: 20px;
    box-sizing: border-box;
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 0px 4px 5px 2px rgba(187, 187, 187, 0.3);
  }

  .material-title {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .material-titleicon {
    width: 4px;
    height: 23px;
    margin-right: 10px;
  }

  .material-titlename {
    font-size: 12px;
  }

  .material-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .material-mesg {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /* margin-right: 20px; */
  }

  .material-mesgicon {
    width: 50px;
    height: 50px;
    background: rgba(255, 247, 215, 1);
    border-radius: 25px;
    margin-bottom: 10px;
  }

  .material-mesgtext {
    font-size: 12px;
  }

  .material-mesgtexttip {
    font-size: 10px;
    color: #666666;
  }

  .inspection-yuyue {
    width: calc(100% - 40px);
    margin: 20px 20px 0 20px;
    height: 46px;
    /*  background: linear-gradient(90deg, rgba(233, 109, 86, 1) 0%, rgba(226, 81, 62, 1) 100%);
    box-shadow: 0px 4px 5px 2px rgba(234, 110, 86, 0.3);
    */
    background: #FD8C00;
    box-shadow: 0 4px 5px 2px rgba(253, 140, 0, 0.3);
    border-radius: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #FFFFFF;
    font-size: 14px;
    position: fixed;
    bottom: 20px;
  }

  .reserceDesc_yuyuemesg {
    width: calc(100% - 40px);
    margin: 20px;
    height: 150px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 4px 5px 2px rgba(187, 187, 187, 0.3);
    border-radius: 8px;
    padding: 20px;
    box-sizing: border-box;
  }

  .reserceDesc_fuwutitle {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }

  .reserceDesc_fuwuimg {
    width: 4px;
    height: 23px;
    margin-right: 10px;
  }

  .reserceDesc_fuwutitlename {
    font-size: 12px;
    /* font-weight: bold; */
    color: rgba(54, 54, 54, 1);
  }

  .reserceDesc_fuwuDetail {
    margin-top: 10px;
    font-size: 12px;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
  }

  .reserceDesc_fuwuname {
    margin-bottom: 15px;
  }

  .reserceDesc_fuwudesc {
    margin-bottom: 15px;
  }

  .reserceDesc_fuwuprice {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }


  .reserceDesc_fuwupricename {}

  .reserceDesc_fuwupricenum {
    font-size: 12px;
    font-weight: 400;
    color: #FD8C00;
  }

  .reserceDesc_jiesuancheck {
    display: flex;
    justify-content: end;
    align-items: center;
  }

  .reserceDesc_jiesuanpricenum {
    font-size: 12px;
    font-weight: 400;
    color: #FD8C00;
    margin-right: 10px;
  }

  .reserceDesc_button {
    margin-top: 21px;
  }

  /* pages/package/reserveDesc.wxss */


  .popup_top {
    display: flex;
    height: 30px;
    padding: 16px;
    border-bottom: 1px solid #d6d6d6;
    align-items: center;
    font-size: 18px;
  }

  .guanbi {
    width: 20px;
    height: 20px;
    margin-right: 130px;
  }

  .couponCell {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
  }

  .reserceDesc_section {
    padding: 10px;
  }

  .addressList {
    width: 100%;
    box-sizing: border-box;
  }

  .addressBox {
    width: 100%;
    border-bottom: 1px solid #D2D2D2;
    padding: 5px 0;
  }

  .address_name {
    font-size: 16px;
  }

  .address_detail {
    font-size: 14px;
    color: #666666;
  }

  /* .map{
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  } */
  .inspection-time {
    font-size: 16px;
    color: #BBBBBB;
    width: 100%;
  }

  .inspection-time1 {
    font-size: 16px;
    color: #000;
    width: 100%;
  }

  .service-price {
    color: #FD8C00;
    font-size: 16px;
  }

  .inspection-bannertip1 {
    font-size: 12px;
    font-weight: bold;
    margin: 15px 0;
    color: #FFFFFF;
  }

  .inspection-bannertip2 {
    font-size: 12px;
    margin-bottom: 10px;
    color: #FFFFFF;
  }

  input:disabled {
    background-color: #fff;
    opacity: 1;
  }
</style>



// WEBPACK FOOTER //
// src/pages/xianxia/yearlyInspection.vue